import React from 'react';
import { useTranslation } from 'react-i18next';
import { translateBlockValue } from 'i18n';

import { capitalize } from 'helpers/helpers';
import { HistoryOriginT } from 'routes/BudgetModule/components/shared/InscriptionsGrid/InscriptionDetails/types';
import { StyHeader, StyHighlightedText } from './StyledComponents';

export type SubCreateEventProps = {
    user: {
        email: string;
    } | null;
    origin?: HistoryOriginT;
};

function SubCreateEvent({
    user,
    origin = 'inscription',
}: SubCreateEventProps): React.ReactElement {
    const { t } = useTranslation();

    const userLabel = user?.email ?? t('common.unknown');

    return (
        <StyHeader>
            <StyHighlightedText>{userLabel}</StyHighlightedText>
            {t('budgetHistory.eventPhase')}
            <StyHighlightedText>
                {capitalize(translateBlockValue(origin))}
            </StyHighlightedText>
        </StyHeader>
    );
}
export default SubCreateEvent;
